import React from 'react';
import { MapPin, Briefcase } from 'lucide-react';
import { careerTimeline } from '../data/mockData';
import '../styles/CareerTimeline.css';

const CareerTimeline = () => {
  return (
    <section id="timeline" className="career-timeline-section">
      <div className="timeline-container">
        <div className="section-header">
          <div className="section-label">Professional Journey</div>
          <h2 className="section-title">Career Timeline</h2>
          <p className="section-description">
            A distinguished career marked by clinical excellence and dedication to patient care
          </p>
        </div>
        
        <div className="timeline-wrapper">
          {careerTimeline.map((item, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-dot-wrapper">
                <div className="timeline-dot"></div>
                {index !== careerTimeline.length - 1 && <div className="timeline-line"></div>}
              </div>
              
              <div className="timeline-content">
                <div className="timeline-year">{item.year}</div>
                <div className="timeline-card">
                  <div className="timeline-role-icon">
                    <Briefcase size={20} />
                  </div>
                  <h3 className="timeline-role">{item.role}</h3>
                  <div className="timeline-institution">
                    <MapPin size={16} />
                    <span>{item.institution}</span>
                  </div>
                  <ul className="timeline-achievements">
                    {item.achievements.map((achievement, idx) => (
                      <li key={idx}>{achievement}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareerTimeline;
